import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=7497324e"
import script from "./FormEditor.vue?vue&type=script&lang=ts"
export * from "./FormEditor.vue?vue&type=script&lang=ts"
import style0 from "./FormEditor.vue?vue&type=style&index=0&id=7497324e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports